import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { VpHookFormInput } from '../../inputs';
import { VpButton } from '../../components';

export const AppSumoInput = ({ onClose }) => {
  const rules = {
    required: {
      value: true,
      message: 'This field is required'
    },
    maxLength: {
      value: 7,
      message: 'Code must be 7 characters'
    },
    minLength: {
      value: 7,
      message: 'Code must be 7 characters'
    },
    pattern: {
      value: /^[a-zA-Z0-9]+$/,
      message: 'Code must be alphanumeric'
    }
  };

  return (
    <>
      <VpHookFormInput
        name="appSumoCode"
        placeholder="Add Code"
        maxLength={7}
        type="text"
        rules={rules}
        required
        fullWidth
      />
      <Stack direction="row" justifyContent="space-between">
        <VpButton onClick={onClose} variant="contained" size="large" color="neutral">
          Cancel
        </VpButton>
        <VpButton type="submit" variant="contained" size="large">
          Apply Code
        </VpButton>
      </Stack>
    </>
  );
};

AppSumoInput.propTypes = {
  onClose: PropTypes.func
};
export default AppSumoInput;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/AppSumoDialog/AppSumoInput.jsx